import React, { useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { GlobalContext } from "../Context/GlobalState";
import { BASE_URL_API_TRANXT_UAT_API } from "../utils/Constant";
import { MdPeople, MdCheckCircle, MdInventory, MdDashboardCustomize, MdAttachMoney, MdLockOpen, MdOutlineManageSearch } from "react-icons/md";
import { FaChartBar, FaChartPie, FaClipboardList, FaClock, FaMoneyBill, FaPlusCircle, FaRegFilePdf, FaTasks, FaUserSlash, FaUsers } from "react-icons/fa";
import { FcSalesPerformance } from "react-icons/fc";
import { GiMoneyStack } from "react-icons/gi";
import { IoMdSettings } from "react-icons/io";

 const iconMapHr = {
   "HR Dashboard": <FaChartPie style={{ color: "Plum" }} />,
   "Employee Management": (
     <MdPeople
       style={{
         color: "#FFC300",
       }}
     />
   ),
   "Salary Management": <FaChartPie style={{ color: "Plum" }} />,
   Perfomance: <FcSalesPerformance style={{ color: "#FEB941" }} />,
   "Attendance Management": (
     <FaClock
       style={{
         color: "Turquoise",
       }}
     />
   ),
   Projects: <FaPlusCircle style={{ color: "yellow" }} />,
   "Vendor Management": <MdInventory style={{ color: "#41B06E" }} />,
   "Budget Analysis": <MdDashboardCustomize style={{ color: "#8B5DFF" }} />,
   "Expense Management": <FaMoneyBill style={{ color: "Plum" }} />,
   "Payroll Management": (
     <MdAttachMoney
       style={{
         color: "yellow",
       }}
     />
   ),
   "Expense Payroll": (
     <FaPlusCircle
       style={{
         color: "orange",
       }}
     />
   ),
   "Contract": (
    <MdAttachMoney
      style={{
        color: "green",
      }}
    />
  ),
  "Leave Management": (
    <MdOutlineManageSearch
      style={{
        color: "yellow", fontSize:"1.2rem"
      }}
    />
  ),
   Arrear: <GiMoneyStack style={{ color: "green" }} />,
   "Account Ledger": <MdAttachMoney style={{ color: "yellow" }} />,
   "Office Inventory": <MdInventory style={{ color: "#41B06E" }} />,
   "Leave Approval": <MdCheckCircle style={{ color: "pink" }} />,
   "Balance Leave": <FaClipboardList style={{ color: "#41B06E" }} />,
   "Add Leave/WFH": <MdCheckCircle style={{ color: "#DAF7A6" }} />,
   Access: <MdLockOpen style={{ color: "yellow" }} />,
   "Create Workspace": <FaPlusCircle style={{ color: "green" }} />,
   "Task Overview": <FaTasks style={{ color: "pink" }} />,
   Policy: <FaRegFilePdf style={{ color: "red" }} />,
   "Inactive Employee": <FaUserSlash style={{ color: "#96C9F4" }} />,
   Settings: <IoMdSettings style={{ color: "yellow" }} />,
   Reports: <FaChartBar style={{ color: "#41B06E" }} />,
   Users: <FaUsers style={{ color: "#41B06E" }} />,
  
 };

const hrLinks = [
    { to: "/Hr/HRDashboard", name: "HR Dashboard" },
  { to: "/Hr/EmployeeManagement", name: "Employee Management" },
  // { to: "/Hr/SalaryManagement", name: "Salary Management" },
  { to: "/Hr/AttendanceManagement", name: "Attendance Management" },
  { to: "/Hr/OfficeInventory", name: "Office Inventory" },
  { to: "/Hr/LeaveManagement", name: "Leave Management" },
  { to: "/Hr/LeaveApproval", name: "Leave Approval" },
  { to: "/Hr/AddLeaveWFH", name: "Add Leave/WFH" },
  { to: "/Hr/ExpenseManagement", name: "Expense Management" },
  // { to: "/Hr/PayrollManagement", name: "Payroll Management" },
  // { to: "/Hr/ExpensePayroll", name: "Expense Payroll" },
  { to: "/Hr/task-overview", name: "Task Overview" },
  { to: "/Hr/Contract", name: "Contract" },
  { to: "/Hr/GenerateArrear", name: "Arrear" },
  { to: "/Hr/AccountLedger", name: "Account Ledger" },
  { to: "/Hr/policy", name: "Policy" },
  { to: "/Hr/inactive-employee", name: "Inactive Employee" },
  { to: "/Hr/Hr-settings", name: "Settings" },
];

const HrSidebar = () => {
  const { pathname } = useLocation();
  const { user, accessData, setAccessData } = useContext(GlobalContext);

  const fetchAccessData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetAccessManagementSuperAdmin`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ firmid: user.firm_id, empid: user.userid }),
        }
      );
      const data = await res.json();
      if (data.status === "0") setAccessData(data.data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (user?.firm_id && user?.userid) fetchAccessData();
  }, [user]);

  const hasAccess = (moduleName) => {
    if (!accessData) return true;
    const mod = accessData.find(m => m.module_name === moduleName);
    return mod ? mod.data.some(r => r.access === "Y") : true;
  };

  return (
    <div style={{ width: "220px", minHeight: "100vh", backgroundColor: "#212529", color: "white" }}>
      <ul className="list-unstyled p-3 mt-3 mb-0">
        <h5 className="mx-2">HR System</h5>
        <hr className="m-1" />
        {hrLinks.map(link => {
          const access = hasAccess(link.name);
          return (
            <li
              key={link.to}
              className={`p-2 d-flex align-items-center ${pathname === link.to ? "bg-light text-dark" : ""}`}
              style={{ opacity: access ? 1 : 0.5, pointerEvents: access ? "auto" : "none" }}
              title={access ? "" : "Access Denied"}
            >
              <Link
                to={access ? link.to : "#"}
                className="text-decoration-none d-flex align-items-center w-100"
                style={{ color: pathname === link.to ? "#000" : "#fff", fontSize: ".8rem", fontWeight: "200" }}
              >
                <span className="me-2" style={{ fontSize: ".9rem" }}>
                  {iconMapHr[link.name] || null}
                </span>
                {link.name}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default HrSidebar;
